import ReactQuill from 'react-quill-new'

export const quillModules = {
  toolbar: [
    [{ header: [2, false] }],
    ['bold', 'italic'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
}

export const getSemanticHtml = (quillRef: React.RefObject<ReactQuill | null>): string => {
  if (quillRef.current) {
    const editor = quillRef.current.getEditor()
    let html = editor.getSemanticHTML()
    html = html.replace(/(&nbsp;)(?!&nbsp;)/g, ' ')
    return html
  }
  return ''
}
